import script from "./MultiImageInputSelector.vue?vue&type=script&setup=true&lang=js"
export * from "./MultiImageInputSelector.vue?vue&type=script&setup=true&lang=js"

import "./MultiImageInputSelector.vue?vue&type=style&index=0&id=35d53d8c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-35d53d8c"]])

export default __exports__